import axios from 'axios';
import user from '../utils/user';

const baseUrl = `${process.env.VUE_APP_API_VIDA_URL}/i4pro/configs`;
const syncUrl = `${process.env.VUE_APP_API_VIDA_URL}/i4pro/sync`;
const batchUrl = `${process.env.VUE_APP_API_VIDA_URL}/i4pro/batches`;

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${user.getUserAuthToken()}`,
  },
});

export default {
  async getConfigs() {
    try {
      const response = await axios.get(baseUrl, authHeaders());
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getOptions(field, dependencyValue) {
    try {
      const dependencySegment =
        dependencyValue !== null &&
        dependencyValue !== undefined &&
        dependencyValue !== ''
          ? `/${encodeURIComponent(String(dependencyValue))}`
          : '';
      const response = await axios.get(
        `${baseUrl}/options/${field}${dependencySegment}`,
        authHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async createConfig(payload) {
    try {
      const response = await axios.post(baseUrl, payload, authHeaders());
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async updateConfig(id, payload) {
    try {
      const response = await axios.patch(
        `${baseUrl}/${id}`,
        payload,
        authHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getSyncLogs(policyId) {
    try {
      const response = await axios.get(`${syncUrl}/${policyId}`, authHeaders());
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async executeSync(policyId, action, payload) {
    try {
      const data = { action };
      if (payload !== undefined) {
        data.payload = payload;
      }
      const response = await axios.post(
        `${syncUrl}/${policyId}`,
        data,
        authHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async reprocessSync(syncId) {
    try {
      const response = await axios.post(
        `${syncUrl}/${syncId}/reprocess`,
        {},
        authHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getPaidInstallments(policyId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/policies/${policyId}/paid-installments`,
        authHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getBatches() {
    try {
      const response = await axios.get(batchUrl, authHeaders());
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async createBatch(payload) {
    try {
      const response = await axios.post(batchUrl, payload, authHeaders());
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
